import GLOBAL from '../util/global';
import ls from '../util/localStorage';
import { IBridge, BridgeType, INetwork, IRegion, IUA } from './types/message.type';

import { getUUID } from '../util/uuid';

const version = require('../../package.json').version; // tslint:disable-line
const userAgent = require('useragent.js'); // tslint:disable-line

const NAV: any = GLOBAL.navigator;
const startTime = +new Date();

const runtime: any = {

    get env(): string {
        return GLOBAL.__prajnaEnv__ || 'beta';
    },

    get project(): string {
        return GLOBAL.__appName__ || '';
    },

    get version(): string {
        return version;
    },

    get unionId(): string {
        return getUUID();
    },

    get autopv(): boolean {
        return GLOBAL.__prajnaAutoPV__ || false;
    },

    get screen(): string {
        return GLOBAL.screen.width + "*" + GLOBAL.screen.height;
    },

    get userAgent(): IUA {
        const ua = NAV.userAgent;
        return {
            ua,
            browser: userAgent.analyze(ua).browser.full || '',
            os: userAgent.analyze(ua).os.full || '',
            device: userAgent.analyze(ua).device.full || '',
            platform: userAgent.analyze(ua).platform.full || '',
        };
    },

    get jsBridge(): IBridge {
        // if jsbridge exists, please write middleware to set accurate values
        return {
            type : BridgeType.NONE,
        };
    },

    get channel(): string {
        return this.core.channel;
    },

    get pageId(): string {
        return this.core.pageId;
    },

    get pageUrl(): string {
        return GLOBAL.location.href;
    },

    get network(): any {
        // get network status
        let connection: string;
        const network: INetwork = {
            online: NAV.onLine,
        };
        // if jsbridge exists, please write middleware to set accurate values
        const conn: any = NAV.connection || NAV.mozConnection || NAV.webkitConnection;
        const type: string = conn && conn.type;
        if (conn) {
            if (type) {
                connection = type;
            }
            if (conn.effectiveType) {
                connection = conn.effectiveType; // high version of Chrome
            }
        }
        if (connection) {
            network.connection = connection;
        }
        return network;
    },

    get region(): IRegion {
        return { lng: '', lat: '' };
    },

    get ['@timestamp'](): string {
        return Date.now().toString();
    },

    get duration(): number {
        const now = +new Date();
        const duration = GLOBAL.performance && GLOBAL.performance.now
            ? Math.floor(GLOBAL.performance.now())
            : Math.floor(now - startTime);
        return duration;
    },

    get localStorage(): any {
        if (GLOBAL.__localStorageList__ && GLOBAL.__localStorageList__.length > 0) {
            const lsObject: any = {};
            GLOBAL.__localStorageList__.forEach((k: string) => {
                lsObject[k] = ls.get(k);
            });
            return lsObject;
        } else {
            return null;
        }
    },
};

export default runtime;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/core/runtime.ts